import React, { useState, useEffect } from 'react'
import { Panel, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import SaveLawTackingForm from './SaveLawTackingForm'
import moment from 'moment'
import ButtonPanelWidget from '../ButtonPanelWidget'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import pathname from '../../constants/pathname'
import LitigationView from './LitigationView'
import { saveLegalFollow } from '../../redux/actions/legal'
import { SAVE_ERR_MSG } from '../../constants/msgText'
import notification from '../../utils/notification'
import { useHistory } from 'react-router-dom'

export default function SaveLawTrackingWidget({ schema, handleCallback = () => {}, ...props }) {
  const history = useHistory()
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(schema)
  const [errorMsg, setErrorMsg] = useState()

  const onSubmit = (data) => {
    console.log('onSubmit data ', data)

    // return false

    // console.log('formSchema ', formSchema)

    var litigationId = formSchema?.litigationId || formSchema?.litigationInfo?.id

    const formData = new FormData()

    data.file &&
      data.file?.forEach((element) => {
        formData.append('Files', element.blobFile)
      })

    formData.append('Id', formSchema.id || '')
    formData.append('LawStatus', data.lawStatus || '')
    formData.append('LawSubStatus', data.lawSubStatus || '')
    // formData.append('TrackingDate', data.trackingDate || '')
    formData.append('TrackingDate', moment(data.trackingDate).format('YYYY/MM/DD') || '')
    formData.append('Note', data.noteOfTracking || '')

    // formData.append('JudgmentDebt', data.judgmentDebt || 0)
    // formData.append('AmountReceived', data.amountReceived || 0)
    // formData.append('AmountRemaining', data.amountRemaining || 0)

    // formData.append('RiskLevel', data.riskLevel || 0)
    // formData.append('YearRemaining', data.yearRemaining || 0)
    // formData.append('DayRemaining', data.dayRemaining || 0)

    formData.append(
      'EdforcementDate',
      data?.edforcementDate ? moment(data.edforcementDate).format('YYYY/MM/DD') : ''
    )
    formData.append('CerrentStatuteOfLimitation', data?.cerrentStatuteOfLimitation || 0)
    formData.append(
      'ExepEdforcementDate',
      data?.exepEdforcementDate ? moment(data.exepEdforcementDate).format('YYYY/MM/DD') : ''
    )
    formData.append('JudgmentDebt', data?.judgmentDebt || 0)
    formData.append('Principle', data?.principle || 0)
    formData.append('InterestRate', data?.interestRate || 0)
    formData.append(
      'PaymentDate',
      data?.paymentDate ? moment(data.paymentDate).format('YYYY/MM/DD') : ''
    )
    formData.append('AmountPaid', data?.amountPaid || 0)
    formData.append('RemainingPrincipalAmount', data?.remainingPrincipalAmount || 0)
    formData.append('RemainingInterest', data?.remainingInterest || 0)
    formData.append('RemainingBalance', data?.remainingBalance || 0)
    formData.append('RiskLevel', data?.riskLevel || 0)

    handleSave(formData, litigationId)
  }

  const handleSave = async (request, litigationId) => {
    setIsLoading(true)
    startLoading()

    console.log('litigationId ', litigationId)

    try {
      const response = await saveLegalFollow(litigationId, request)
      // console.log('resssssss ', response)
      if (response) {
        setFormSchema(response)

        notification.open('success', {
          title: 'บันทึกสำเร็จ',
          duration: 10000,
        })

        setTimeout(() => {
          handleCallback()
          // sessionStorage.setItem('projectId', 'menu')
          // history.push({
          //   pathname: `${pathname.law.ManageLegal}`,
          //   // pathname: `${pathname.law.ManageLegal}/menu`,
          // })
        }, 1000)
      } else {
        setIsError(true)
        setErrorMsg(SAVE_ERR_MSG)
      }
    } catch (error) {
      console.error(error)
      setErrorMsg(SAVE_ERR_MSG)
    }

    doneLoading()
    setIsLoading(false)
  }

  const onCancel = () => {
    sessionStorage.setItem('projectId', 'menu')

    history.push({
      pathname: `${pathname.law.ManageLegal}`,
      // pathname: `${pathname.law.ManageLegal}/menu`,
    })
    // window.location.href = pathname.law.ManageLegal + '/menu'
    // window.opener = null
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded bordered>
        {formSchema?.litigationInfo && <LitigationView schema={formSchema?.litigationInfo} />}

        {formSchema?.inputForm && (
          <SaveLawTackingForm
            lawType={formSchema?.litigationInfo?.lawType?.id}
            schema={formSchema.inputForm}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            clearErrors={clearErrors}
            litigationId={formSchema?.litigationId || formSchema?.litigationInfo?.id}
            isFirstTimeEnableEdit={formSchema?.isFirstTimeEnableEdit ?? false}
          />
        )}

        {isLoading && !isError && <OverlayLoader />}

        <hr />

        {errorMsg && (
          <Message showIcon type={'error'} description={errorMsg} style={{ marginBottom: 20 }} />
        )}

        {formSchema?.inputForm?.buttonText && (
          <ButtonPanelWidget
            isEdit={true}
            // errorMsg={SAVE_ERR_MSG}
            // isError={isError}
            buttonText={formSchema.inputForm.buttonText}
            onSave={handleSubmit(onSubmit)}
            onCancel={onCancel}
          />
        )}
      </Panel>
    </>
  )
}
